/*
 * Application Insights JavaScript SDK - React Native Plugin, 4.4.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import DeviceInfo from "react-native-device-info";
/**
 * Returns the "react-native-device-info" as the Device Info Module
 * @returns
 */
export function getReactNativeDeviceInfo() {
    return DeviceInfo;
}
//# sourceMappingURL=ReactNativeDeviceInfo.js.map